import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Set from "@babel/runtime-corejs3/core-js-stable/set";
export default function getUniqueFieldNames(objects) {
  var fields = new _Set();
  _forEachInstanceProperty(objects).call(objects, function (o) {
    var _context;
    _forEachInstanceProperty(_context = _Object$keys(o)).call(_context, function (field) {
      fields.add(field);
    });
  });
  return fields;
}